module.exports = __webpack_public_path__ + "img/left.1a36d5c0.svg";